import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/PageHome.vue')
  },
  {
    path: '/price/',
    name: 'price',
    component: () => import('@/pages/PagePrice.vue')
  },
  {
    path: '/profiles/',
    name: 'profiles',
    component: () => import(/* webpackChunkName: "about" */ '@/pages/PageProfiles.vue')
  },
  {
    path: '/scat/',
    name: 'scat',
    component: () => import('@/pages/PageScat.vue')
  },
  {
    path: '/upload/',
    name: 'upload',
    component: () => import('@/pages/PageUpload.vue')
  },
  {
    path: '/feeds/',
    name: 'feeds',
    component: () => import('@/pages/PageFeeds.vue')
  },
  {
    path: '/suppliers/',
    name: 'suppliers',
    component: () => import('@/pages/PageSuppliers.vue')
  },
  {
    path: '/formulas/',
    name: 'formulas',
    component: () => import('@/pages/PageFormulas.vue')
  },
  {
    path: '/currencies/',
    name: 'currencies',
    component: () => import('@/pages/PageCurrencies.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
